<template>
  <div class="fixed z-[500] pointer-events-none" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-200 pointer-events-none opacity-0" :class="show && 'pointer-events-auto !opacity-100'" @click.self.stop="show = false"></div>

    <div class="fixed z-10 inset-0 overflow-y-auto pointer-events-none">
      <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
        <transition
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            v-if="show"
            class="relative bg-white pointer-events-auto rounded-lg text-left shadow-xl transform transition-all sm:my-8 h-[70em] overflow-auto sm:max-w-[120em] sm:w-full"
          >
            <div v-if="allowSearch" class="flex p-4 relative mb-4">
              <div class="left-0 top-0 grow relative">
                <input
                  v-model="search"
                  class="block outline-none rounded-xl border border-gray-200 h-[34px] w-full pl-12 bg-transparent focus:outline-blue-600"
                  :placeholder="allowSearch ? 'Search product...(SKU, name)' : 'Search product...'"
                  ref="searchEl"

                  @keydown="keydown"
                >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-gray-600 mt-2.5 ml-3 absolute left-0 top-0 w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>

                <div class="my-2 flex space-x-2">
                  <span
                    v-for="(sku, index) in skuTags"
                    :key="sku"

                    class="inline-flex items-center rounded-md bg-green-100 px-3 pr-1 py-0.5 text-sm font-medium text-green-800"
                    @click="removeSkuIndex(index)"
                  >
                    <span><span class="text-green-800 font-normal">SKU: </span> {{ sku }}</span>
                    <svg class="w-4 h-4 ml-1 cursor-pointer hover:text-green-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </span>
                </div>
                <p>
                  Type "," to search by multiple skus.
                </p>
              </div>
            </div>

            <div class="p-6">
              <div v-if="!allowSearch" class="min-h-[70em] grid items-start grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-10 lg:grid-cols-5 lg:gap-x-8">
                <ProductItem
                  v-for="product in products"
                  :key="product.id"
                  v-bind="product"

                  :active="product.id === context.productId"
                  @click.native="selectProduct(product)"
                />
              </div>
              <div v-if="products.length" class="min-h-[70em] grid items-start grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-10 lg:grid-cols-5 lg:gap-x-8">
                <ProductItem
                  v-for="product in products"
                  :key="product.id"
                  v-bind="product"

                  :active="isSearchProductSelected(product)"
                  @click.native="selectSearchedProduct(product)"
                />
              </div>
              <div v-else class="h-[70em] flex justify-center items-center">
                <div class="text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto h-20 w-20 text-gray-400">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                  </svg>

                  <h3 class="mt-2 text-sm font-semibold text-gray-900">Search your products</h3>
                </div>
              </div>
            </div>

            <div v-if="saveButton" class="flex justify-end space-x-3 border-t border-gray-200 px-4 py-5 sm:px-6 sticky bg-white bottom-0 left-0 w-full">
              <button @click="close" type="button" class="rounded-md bg-white py-2 px-3 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Cancel</button>
              <button
                type="submit"
                class="inline-flex justify-center rounded-md bg-indigo-600 py-2 px-3 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                :class="isSaveBtnDisabled && 'pointer-events-none !bg-gray-600 !opacity-60'"

                @click="save"
              >
                <slot name="save"></slot>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex"

import ProductItem from "./ProductItem"

export default {
  components: {
    ProductItem,
  },
  props: ['value', 'allowSearch', 'category', 'multipleSelect', 'saveButton'],
  data() {
    return {
      show: this.value,
      search: '',
      loading: false,
      products: [],
      timeout: null,
      selected: false,
      selectedSkus: [],
      skuTags: [],
    }
  },
  created() {
    this.loadProducts()
  },
  methods: {
    removeSkuIndex(index) {
      this.skuTags.splice(index, 1)
    },
    keydown({ key }) {
      if (key === ',') {
        this.$nextTick(() => {
          this.skuTags.push(this.search)
          setTimeout(() => this.search = "", 100)
        })
      }
    },

    save() {
      this.$emit('save', this.multipleSelect ? this.selectedSkus : this.selected)
      this.close()
    },
    close() {
      if (this.multipleSelect) this.selectedSkus = []
      this.show = false
    },

    isSearchProductSelected(product) {
      if (!this.multipleSelect) return this.selected === product.sku
      else return this.selectedSkus.includes(product.sku)
    },
    selectSearchedProduct(product) {
      if (!this.multipleSelect) this.selected = product.sku
      else {
        const i = this.selectedSkus.indexOf(product.sku)
        if (i > -1) this.selectedSkus.splice(i, 1)
        else this.selectedSkus.push(product.sku)
      }
    },
    async loadCategoryProducts() {
      this.products = (await this.axios.get(`${this.link}/rest/V1/editor/products-by-category/${this.category.id}`, {
        headers: { Cookie: 'environment=editor' }
      })).data
      this.products[0] && this.selectProduct(this.products[0])
    },
    async loadAllProducts() {
      if (!this.search && !this.skuTags.length) return this.products = []

      const { data } = await this.axios.get(`/api/products`, {
        params: {
          search: this.search,
          page_size: 10,
          skus: this.skuTags,
        },
      })

      this.products = data.results.map(product => ({
        id: product.sku,
        name: product.name,
        description: product.short_description,
        brand: product.brand,
        sku: product.sku,
        price: product.buy_price,
        src: null,
      }))

      this.products = await Promise.all(
        this.products.map(async product => {
          try {
            const { data } = await this.axios.get(`/api/products/${product.sku}/files`)
            const file = data.results.find(item => item.is_main) || data.results[0]
            product.src = file.url
            return product
          } catch (err) {
            return null
          }
        })
      )
    },
    async loadProducts() {
      this.loading = true
      await (this.category ? this.loadCategoryProducts() : this.loadAllProducts())
      this.loading = false
    },
    selectProduct(product) {
      this.$emit('select', product)
    },
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
      context: 'editor/context',
    }),

    isSaveBtnDisabled() {
      if (this.multipleSelect) return !this.selectedSkus.length
      return !this.selected
    },
  },
  watch: {
    skuTags() {
      this.loadAllProducts()
    },
    search() {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      this.timeout = setTimeout(() => this.loadAllProducts(), 250)
    },
    products(products) {
      this.$emit("products", products)
    },
    value(val) {
      this.show = val
    },
    show(show) {
      this.$emit('input', show)
    },
    category() {
      this.loadProducts()
    },
  },
}

</script>
